module.exports = __webpack_public_path__ + "assets/img/qYU8J9N5UVJV2Fnt.e046f367.png";